<ng-container *ngIf="{
    request: requestDeviceFwInfo$ | async,
    data: device$ | async
  } as resolver">
  <ng-container *ngIf="resolver.data as device; else skeletonView">
    <lib-block-title
      *ngIf="uiFramework === 'material'"
      data-testid="device-details-title"
      id="detail-title"
      [title]="labels.title">
    </lib-block-title>
    <div
      id="product-image"
      class="fx-col fx-gap-2 py-2 fx-center radius-4 block-bg-contrast">
      <img
        *ngIf="device.product.type?.name"
        class="h-20"
        [src]="productImageSrc ??
          ('blocks-assets/images/productImages/' + device.product.type?.imgName)">
      <span class="tw-font-medium tw-text-sm text-grey-400">
        {{ device.prettyName }}
      </span>
      <span
        id="product-id"
        class="ellipsed tw-font-normal tw-text-base text-grey-400">
        {{ device.product.id }}
      </span>
    </div>
    <section
      *ngIf="device.properties.length"
      id="product-details">
      <div
        *ngFor="let property of device.properties"
        class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
        <mat-icon
          *ngIf="uiFramework === 'material'"
          class="text-grey-400">
          {{ property.icon ?? 'info' }}
        </mat-icon>
        <ion-icon
          *ngIf="uiFramework === 'ionic'"
          class="text-grey-300 s-6 min-s-6"
          [name]="property.icon ?? 'information-circle-outline'">
        </ion-icon>
        <div class="tw-text-sm tw-font-medium text-grey-300">
          {{ property.name | titlecase }}
        </div>
        <div
          class="tw-text-base tw-font-normal text-grey-400 ml-auto"
          [ngClass]="property.cssClasses">
          {{ property.value }}
        </div>
      </div>
    </section>
  </ng-container>

  <ng-template #skeletonView>
    <lib-block-title
      *ngIf="uiFramework === 'material'"
      data-testid="device-details-title"
      id="detail-title"
      [title]="labels.title">
      <ion-skeleton-text
        animated="true"
        class="h-6 w-32">
      </ion-skeleton-text>
    </lib-block-title>
    <div
      id="product-image"
      class="fx-col fx-gap-2 py-2 fx-center radius-4 block-bg-contrast">
      <ion-skeleton-text
        animated="true"
        class="h-20 w-20">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated="true"
        class="h-5 w-32">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated="true"
        class="h-5 w-24">
      </ion-skeleton-text>
    </div>
    <section id="product-details">
      <div
        *ngFor="let i of [].constructor(6)"
        class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
        <ion-skeleton-text
          animated="true"
          class="h-6 w-6">
        </ion-skeleton-text>
        <ion-skeleton-text
          animated="true"
          class="h-5 w-24">
        </ion-skeleton-text>
        <ion-skeleton-text
          animated="true"
          class="h-5 w-24 ml-auto">
        </ion-skeleton-text>
      </div>
    </section>
  </ng-template>
</ng-container>
